// src/context/WishlistContext.jsx

import React, { createContext, useContext, useReducer, useState } from 'react';
import Toast from '../components/Toast'; // تأكد من أن هذا المسار صحيح لمكون Toast.jsx

// Wishlist Context
const WishlistContext = createContext();

// Wishlist Actions
const WISHLIST_ACTIONS = {
  ADD_ITEM: 'ADD_ITEM',
  REMOVE_ITEM: 'REMOVE_ITEM',
  CLEAR_WISHLIST: 'CLEAR_WISHLIST',
};

// Wishlist Reducer
const wishlistReducer = (state, action) => {
  switch (action.type) {
    case WISHLIST_ACTIONS.ADD_ITEM: {
      const existingItem = state.items.find((item) => item.id === action.payload.id);

      if (existingItem) {
        return state; // العنصر موجود بالفعل، لا تضيفه مرة أخرى
      } else {
        return {
          ...state,
          items: [...state.items, action.payload],
        };
      }
    }

    case WISHLIST_ACTIONS.REMOVE_ITEM: {
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload),
      };
    }

    case WISHLIST_ACTIONS.CLEAR_WISHLIST: {
      return {
        ...state,
        items: [],
      };
    }

    default:
      return state;
  }
};

// Initial state
const initialState = {
  items: [],
};

// Wishlist Provider Component
export const WishlistProvider = ({ children }) => {
  const [state, dispatch] = useReducer(wishlistReducer, initialState);
  const [toast, setToast] = useState(null); // تعريف حالة رسالة التأكيد

  // Wishlist functions
  const addToWishlist = (product) => {
    // التحقق من أن المنتج غير موجود مسبقًا قبل إضافة رسالة التأكيد
    const existingItem = state.items.find((item) => item.id === product.id);
    if (!existingItem) {
      dispatch({ type: WISHLIST_ACTIONS.ADD_ITEM, payload: product });
      setToast({ message: `تمت إضافة ${product.name} إلى قائمتك المفضلة!`, type: 'success' });
    } else {
      setToast({ message: `${product.name} موجود بالفعل في القائمة.`, type: 'info' });
    }
    setTimeout(() => setToast(null), 3000);
  };

  const removeFromWishlist = (productId) => {
    const product = state.items.find((item) => item.id === productId);
    dispatch({ type: WISHLIST_ACTIONS.REMOVE_ITEM, payload: productId });
    if (product) {
      setToast({ message: `تم حذف ${product.name} من القائمة المفضلة.`, type: 'info' });
    }
    setTimeout(() => setToast(null), 3000);
  };

  const clearWishlist = () => {
    dispatch({ type: WISHLIST_ACTIONS.CLEAR_WISHLIST });
  };

  const isInWishlist = (productId) => {
    return state.items.some((item) => item.id === productId);
  };

  // Calculated values
  const totalItems = state.items.length;

  const value = {
    items: state.items,
    totalItems,
    addToWishlist,
    removeFromWishlist,
    clearWishlist,
    isInWishlist,
  };

  return (
    <WishlistContext.Provider value={value}>
      {children}
      {/* عرض رسالة التأكيد هنا */}
      {toast && <Toast message={toast.message} type={toast.type} />}
    </WishlistContext.Provider>
  );
};

// Custom hook to use wishlist context
export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within a WishlistProvider');
  }
  return context;
};
